/** "R$ 1.200,99": sempre com centavos, no padrão brasileiro. */
export const formatPrice = (price) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
}).format(price);

/** "45 min", "1h" ou "1h 30min" a partir de "HH:mm:ss". */
export const formatDuration = (duration) => {
    const [hours, minutes] = String(duration || '00:00').split(':');
    const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
    if (totalMinutes < 60) {
        return `${totalMinutes} min`;
    }
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return m > 0 ? `${h}h ${m}min` : `${h}h`;
};

export const isInactive = (procedure) => procedure.Active == 0;
